module.exports = __webpack_public_path__ + "img/green_lock.5fb936db.png";